import { startLinkedApp } from './linkedAppSso';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { AuthContext, AuthProvider,useAuth } from "./authContext";
const root = ReactDOM.createRoot(document.getElementById('root'));
startLinkedApp(() => {
root.render(
  <RecoilRoot>
    <BrowserRouter>
    <AuthProvider>
      <App />
      </AuthProvider>
    </BrowserRouter>
  </RecoilRoot>
);
}, '/api/sso-handoff');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
